import React, { useReducer } from 'react';
import { ThemeProvider } from 'styled-components';
import { HelmetProvider } from 'react-helmet-async'
import {theme} from "./theme"
import {Router} from "./router"
//

// Handle the only global state using context instead of Redux
interface QueryReducerAction{
  type: string
  query: any
}

const QueryReducer = (state: any, action: QueryReducerAction) => {
  switch (action.type) {
    case "UPDATE_QUERY":
      // NOTE: existing items are overwritten by newer ones
      return { ...state, ...action.query }
    case "CLEAR_QUERY":
      return {}
  }
}

interface IContextProps {
  query: any
  dispatchQuery: React.Dispatch<QueryReducerAction>
}

export const QueryStore = React.createContext({} as IContextProps)

function App() {
  const [query, dispatchQuery] = useReducer(QueryReducer, {})

  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider>
      <QueryStore.Provider value={{query, dispatchQuery}}>
        <Router></Router>
      </QueryStore.Provider>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
